import BCMS, { Route } from "@bcm-dev/bcms-vite";
import CameraViewPage from "components/pages/CameraViewPage";
import CapturePage from "components/pages/CapturePage";
import ContentPage from "components/pages/ContentPage";
import LoginFastBalancesPage from "components/pages/LoginFastBalancesPage";
import LoginPage from "components/pages/LoginPage";
import NoFooter from "components/pages/NoFooterPage";
import BottomNavWrapper from "components/shared/wrappers/BottomNavWrapper";
import "res/css/material-icon/MaterialIcons-Regular.codepoints?url";
import "res/css/material-icon/MaterialIcons-Regular.ttf";
import "res/css/material-icon/MaterialIconsOutlined-Regular.codepoints?url";
import "res/css/material-icon/MaterialIconsOutlined-Regular.otf";
import "res/css/material-icon/MaterialIconsRound-Regular.codepoints?url";
import "res/css/material-icon/MaterialIconsRound-Regular.otf";
import "res/css/material-icon/MaterialIconsSharp-Regular.codepoints?url";
import "res/css/material-icon/MaterialIconsSharp-Regular.otf";
import "res/css/material-icon/MaterialIconsTwoTone-Regular.codepoints?url";
import "res/css/material-icon/MaterialIconsTwoTone-Regular.otf";
import "res/css/material-icon/MaterialSymbolsOutlined[FILL,GRAD,opsz,wght].codepoints?url";
import "res/css/material-icon/MaterialSymbolsOutlined[FILL,GRAD,opsz,wght].ttf";
import "res/css/material-icon/MaterialSymbolsOutlined[FILL,GRAD,opsz,wght].woff2";
import "res/css/material-icon/MaterialSymbolsRounded[FILL,GRAD,opsz,wght].codepoints?url";
import "res/css/material-icon/MaterialSymbolsRounded[FILL,GRAD,opsz,wght].ttf";
import "res/css/material-icon/MaterialSymbolsRounded[FILL,GRAD,opsz,wght].woff2";
import "res/css/material-icon/MaterialSymbolsSharp[FILL,GRAD,opsz,wght].codepoints?url";
import "res/css/material-icon/MaterialSymbolsSharp[FILL,GRAD,opsz,wght].ttf";
import "res/css/material-icon/MaterialSymbolsSharp[FILL,GRAD,opsz,wght].woff2";
import "./res/css/layout-styles.css";
import "./res/css/shared-styles.css";
// Capture components
import CaptureFaceIDLogin from "components/captures/Face ID/009_FaceID_Login";
import CaptureFastBalancesLogin from "components/captures/Fast Balances/001_Login";
import CaptureFastBalancesSetup from "components/captures/Fast Balances/002_FastBalanceSetup";
import CaptureFastBalancesPasswordEntered from "components/captures/Fast Balances/003_PasswordEntered";
import CaptureFastBalancesSetupView from "components/captures/FastBalances/CaptureFastBalancesSetupView";
import CaptureLogin from "components/captures/FirstTimeLogin/001_Login";
import CaptureUserIDentered from "components/captures/FirstTimeLogin/002_UserIDentered";
import CapturePasswordEntered from "components/captures/FirstTimeLogin/003_PasswordEntered";
import { Navigate } from "react-router";

function App() {
    return (
      <BCMS env={ import.meta.env } customCSS="custom_css_mabi23" customMenu="true">
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<LoginPage />} />
         <Route path="/base" element={<BottomNavWrapper />} />
        <Route path="/login/:nowrapper" element={<LoginPage />} />
        <Route path="/loginfastbalances" element={<LoginFastBalancesPage />} />
        <Route path="/cameraview" element={<CameraViewPage />} />
        <Route path="/content" element={<ContentPage page={"accountSummary"}/>} />
        <Route path="/noFooter/:page" element={<NoFooter />} />
        <Route path="/noFooter" element={<NoFooter page={"accountSummary"}/>} />
        <Route path="/content/:page" element={<ContentPage />} />
        <Route path="/content/:page/:menu" element={<ContentPage />} />
        <Route path="/capture" element={<CapturePage page={"accountSummary"}/>} />
        <Route path="/capture/:page" element={<CapturePage />} />
        <Route path="/capture/:page/:footer" element={<CapturePage />} />

        {/* Capture components */}
        <Route path="/captureFastBalancesSetupView" element={<CaptureFastBalancesSetupView />} />
        <Route path="/captureFastBalancesSetupView/:nowrapper" element={<CaptureFastBalancesSetupView />} />

        <Route path="/captureFaceIDLogin/:nowrapper" element={ <CaptureFaceIDLogin /> } />
        <Route path="/captureLogin/:nowrapper" element={ <CaptureLogin /> } />
        <Route path="/captureUserIDentered/:nowrapper" element={ <CaptureUserIDentered /> } />
        <Route path="/capturePasswordEntered/:nowrapper" element={ <CapturePasswordEntered /> } />

        {/* Fast Balances capture components */}
        <Route path="/captureFastBalancesLogin/:nowrapper" element={ <CaptureFastBalancesLogin /> } />
        <Route path="/captureFastBalancesSetup/:nowrapper" element={ <CaptureFastBalancesSetup /> } />
        <Route path="/captureFastBalancesPasswordEntered/:nowrapper" element={ <CaptureFastBalancesPasswordEntered /> } />



      </BCMS>
  );
}

export default App;
